import React from 'react'
import  GlobeHemisphereWestkSVG from "../../assets/icons/GlobeHemisphereWest.svg";

const GlobeHemisphereWest = ({ className = '' }) => {
  return (
    <img
      src={ GlobeHemisphereWestkSVG}
      alt="Globe Hemisphere West"
      className={`${className}`}
    />
  );
};

export default GlobeHemisphereWest;
